/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DistrictResource { 
    /**
     * The code of the district.
     */
    code: string;
    /**
     * The name of the district.
     */
    name: string;
    /**
     * The short name of the district.
     */
    shortName: string;
    /**
     * The status of the district.
     */
    isActive: boolean;
    /**
     * The date when the district was established.
     */
    establishedDate: string;
    /**
     * The note about the establishment of the district.
     */
    establishedNote: string | null;
    /**
     * The date when the district was terminated.
     */
    terminatedDate: string | null;
    /**
     * The note about the termination of the district.
     */
    terminatedNote: string | null;
    /**
     * The NUTS4 code of the district.
     */
    nuts4: string;
    /**
     * The code of the region.
     */
    regionCode: string;
}

